export default "__VITE_ASSET__xSRrsNjo__"